import { Component, OnInit, inject, PLATFORM_ID, ChangeDetectionStrategy } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../environment/environment';
import { Meta, Title } from '@angular/platform-browser';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { ApiLoaderComponent } from './core/api-loader/api-loader.component';
import { MessageService } from './services/message.service';
import { ConfigService } from './services/config.service';
import { AppConfig } from './models/config.interface';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ApiLoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  title = 'fe-wareed-admin';

  titleService = inject(Title);
  metaService = inject(Meta);
  router = inject(Router);
  messageService = inject(MessageService);
  configService = inject(ConfigService);
  private platformId = inject(PLATFORM_ID);

  async ngOnInit(): Promise<void> {
    this.titleService.setTitle('Wareed Medical Laboratories');
    this.metaService.updateTag({ name: 'description', content: 'The premier ride experience' });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => this.hideSplash(), 100);
      }
    });

    if (isPlatformBrowser(this.platformId)) {
      // Wait for config before initializing services that depend on it
      this.configService.config$.subscribe((config: AppConfig | null) => {
        if (config) {
          this.messageService.init();
          this.loadGoogleMapsScript();
        }
      });
      this.messageService.notification$.subscribe((_payload) => {});
    }
  }

  loadGoogleMapsScript() {
    if (!isPlatformBrowser(this.platformId) || !environment.googleMapsKey) {
      return;
    }

    const existingScript = document.getElementById('google-maps-script') as HTMLScriptElement;
    if (existingScript) {
      // If the script already exists with the correct key, don't re-add
      if (existingScript.src.includes(environment.googleMapsKey)) {
        return;
      }
      // If it exists but with a different key (or empty), remove it to reload
      existingScript.remove();
    }

    const script = document.createElement('script');
    script.id = 'google-maps-script';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsKey}&libraries=places`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }

  hideSplash() {
    const splash = document.getElementById('splash-screen');
    if (splash) {
      splash.style.opacity = '0';
      splash.style.transition = 'opacity 0.3s ease';
      setTimeout(() => splash.remove(), 300);
    }
  }
}
